import { queryOptions } from '@tanstack/react-query';
import { cmsQueryKeys } from '../cms/cmsQueryKeys';
import { getPartialBySlug } from '../cms/getPartialBySlug';

export const footerDownloadAppQueryOptions = queryOptions({
  queryKey: [...cmsQueryKeys.getPartialBySlug, 'download-app'],
  queryFn: () => getPartialBySlug({ slug: 'download-app' }),
  staleTime: Infinity,
});
